"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublishedCollection = void 0;
var send_request_1 = require("../utils/send-request");
var SEPARATOR = '_';
function getPublishedCollection(_a) {
    var id = _a.id, metaSiteId = _a.metaSiteId, _b = _a.baseUrl, baseUrl = _b === void 0 ? 'https://collections.wixstatic.com/' : _b, _c = _a.transport, transport = _c === void 0 ? send_request_1.sendRequest : _c;
    function loadById(collectionId) {
        return transport({
            url: "".concat(baseUrl, "collections/").concat(encodeURIComponent(collectionId), ".json"),
        }).then(function (_a) {
            var data = _a.data;
            return data.collection;
        });
    }
    if (metaSiteId === null) {
        return loadById(id);
    }
    return loadById("".concat(metaSiteId).concat(SEPARATOR).concat(id)).catch(function (reason) {
        var _a, _b;
        var status = (_a = reason === null || reason === void 0 ? void 0 : reason.status) !== null && _a !== void 0 ? _a : (_b = reason === null || reason === void 0 ? void 0 : reason.response) === null || _b === void 0 ? void 0 : _b.status;
        if (status === 403 || status === 404) {
            return loadById(id);
        }
        return Promise.reject(reason);
    });
}
exports.getPublishedCollection = getPublishedCollection;
//# sourceMappingURL=getPublishedCollection.js.map